import {
  LIST_SERVICE_CATEGORY_REQUEST,
  LIST_SERVICE_CATEGORY_SUCCESS,
  LIST_SERVICE_CATEGORY_FAIL,
  LIST_SERVICE_CATEGORY_SUMMARY_REQUEST,
  LIST_SERVICE_CATEGORY_SUMMARY_SUCCESS,
  LIST_SERVICE_CATEGORY_SUMMARY_FAIL,
  CREATE_SERVICE_CATEGORY_REQUEST,
  CREATE_SERVICE_CATEGORY_SUCCESS,
  CREATE_SERVICE_CATEGORY_FAIL,
  DETAIL_SERVICE_CATEGORY_REQUEST,
  DETAIL_SERVICE_CATEGORY_SUCCESS,
  DETAIL_SERVICE_CATEGORY_FAIL,
  UPDATE_SERVICE_CATEGORY_REQUEST,
  UPDATE_SERVICE_CATEGORY_SUCCESS,
  UPDATE_SERVICE_CATEGORY_FAIL,
  DELETE_SERVICE_CATEGORY_REQUEST,
  DELETE_SERVICE_CATEGORY_SUCCESS,
  DELETE_SERVICE_CATEGORY_FAIL,
  RESET_SERVICE_CATEGORY
} from '../../constants/service-categories'

const initialState = {
  loading: false,
  serviceCategories: [],
  serviceCategory: {},
  serviceCategoriesSummary: [],
  error: null,
  pageable: {}
}

const serviceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_SERVICE_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case LIST_SERVICE_CATEGORY_SUCCESS:
      return { ...state, loading: false, serviceCategories: action.payload, pageable: action.pageable }
    case LIST_SERVICE_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_SERVICE_CATEGORY_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_SERVICE_CATEGORY_SUMMARY_SUCCESS:
      return { ...state, loading: false, serviceCategoriesSummary: action.payload }
    case LIST_SERVICE_CATEGORY_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_SERVICE_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case CREATE_SERVICE_CATEGORY_SUCCESS:
      return { ...state, loading: false }
    case CREATE_SERVICE_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DETAIL_SERVICE_CATEGORY_REQUEST:
      return { loading: true }
    case DETAIL_SERVICE_CATEGORY_SUCCESS:
      return { loading: false, serviceCategory: action.payload }
    case DETAIL_SERVICE_CATEGORY_FAIL:
      return { loading: false, error: action.payload }
    case UPDATE_SERVICE_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case UPDATE_SERVICE_CATEGORY_SUCCESS:
      return { ...state, loading: false }
    case UPDATE_SERVICE_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case DELETE_SERVICE_CATEGORY_REQUEST:
      return { ...state, loading: true }
    case DELETE_SERVICE_CATEGORY_SUCCESS:
        const serviceCategoryId = action.payload
        const indexServiceCategory = state.serviceCategories.findIndex(serviceCategory => serviceCategory.id === serviceCategoryId)
        state.serviceCategories.splice(indexServiceCategory, 1)

      return { ...state, loading: false }
    case DELETE_SERVICE_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case RESET_SERVICE_CATEGORY:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default serviceCategoryReducer